import api from '@/api';

import { PageResult } from '@/core/request/PageResult';

import {
  Recommendation,
  RecommendationCreateRequest,
  RecommendationListQuery,
  RecommendationUpdateRequest,
} from './Recommendation.types';

import { API_BASE_URL } from '..';

const CONTROLLER_URL = `${API_BASE_URL}/recommendation`;

export async function listRecommendations(
  params?: RecommendationListQuery,
): Promise<PageResult<Recommendation>> {
  const result = (await api.get(`${CONTROLLER_URL}`, params)) as unknown;

  return result as PageResult<Recommendation>;
}

export async function getRecommendation(id?: number): Promise<Recommendation> {
  const result = (await api.get(`${CONTROLLER_URL}/${id}`, null)) as unknown;

  return result as Recommendation;
}

export async function createRecommendation(
  obj: RecommendationCreateRequest,
): Promise<Recommendation> {
  const result = (await api.post(`${CONTROLLER_URL}`, obj, null)) as unknown;

  return result as Recommendation;
}

export async function updateRecommendation(
  obj: RecommendationUpdateRequest,
): Promise<Recommendation> {
  const result = (await api.put(`${CONTROLLER_URL}`, obj, null)) as unknown;

  return result as Recommendation;
}

export async function deleteRecommendation(recommendationId: number) {
  const result = (await api.remove(
    `${CONTROLLER_URL}/${recommendationId}`,
    {},
    null,
  )) as unknown;

  return result;
}
